import type { HTMLAttributes } from 'react';

type DsPillStatus = 'pos' | 'neg' | 'warn' | 'muted' | 'info';

interface DsPillProps extends HTMLAttributes<HTMLSpanElement> {
  status?: DsPillStatus;
}

export function DsPill({ status, className = '', children, ...props }: DsPillProps) {
  const classes = ['ds-pill', status, className].filter(Boolean).join(' ');
  return (
    <span className={classes} {...props}>
      {children}
    </span>
  );
}

type DsFlagSeverity = 'critical' | 'warn' | 'deal' | 'info';

interface DsFlagProps extends HTMLAttributes<HTMLSpanElement> {
  severity: DsFlagSeverity;
}

export function DsFlag({ severity, className = '', children, ...props }: DsFlagProps) {
  const classes = ['ds-flag', severity, className].filter(Boolean).join(' ');
  return (
    <span className={classes} {...props}>
      {children}
    </span>
  );
}
